import TabPage from "./../../factories/tab-page";
import "./../../bindings/bao-searcher";
import "./../../bindings/bao-toolbar2";
import GenericListTab from "./../../factories/generic-list-tab";
import Bao from "./../../services/bao-service";
import * as ko from "knockout";
import BaoDialogViewModel from "./../../factories/bao-dialog";
class ConfigurationItem250BillingPlanViewModel extends GenericListTab {
    public ConfigurationItem: KnockoutObservable<any>;
    constructor(tabPage: TabPage, parent: any) {
        super(tabPage, parent);
        this.ConfigurationItem = parent;
    }
    CustomFilter() {
        return null;
    }
    ItemCompleteCheck(item: any): JQueryPromise<boolean> {
        //Dummy, wird im Dialog überschrieben
        return null;
    }
    public Edit(item) {
        if (item != null) {
            this.Dialog(ko.unwrap(item.PrimaryKeyValue));
        }
    }
}
export default ConfigurationItem250BillingPlanViewModel;